import { useContext } from 'react';
import { Button, Tooltip } from 'antd';

import { logout } from '../../utils/auth';
import { BiLogOutCircle } from "react-icons/bi";
import { RootContext } from '../../context/RootContext';



export default function Logout({ configure = false}) {
	const { dispatch } = useContext(RootContext);

  const logouts = () => {
    logout()
    dispatch({
      type: 'LOGOUT',
      redirectTo: configure ? "/loginconfiguration" : "/login"
    });
  };

  return (
    <Tooltip title="Logout" placement="bottom">
      <Button 
        shape="circle"
        className="text-sky-700"
        onClick={logouts}
        icon={<BiLogOutCircle size = '24'/>} />
    </Tooltip>
  );
}